<template>
  <div class="scence" style="font-size:16px;width:100%;background:#eff1f5">
    <div class="content" ref="content">
      <div class="skt" ref="skt">
        <div class="select">
          <span class="xzqh">水闸名称:</span>
          <div class="selcountry">
            <el-input v-model="query.searchName" placeholder="请输入" clearable @change="Global.emptyQuery(query.searchName,searchTheData)"></el-input>
          </div>
          <span class="xzqh">水闸类型:</span>
          <div class="selcountry">
            <el-select v-model="query.sluiceType" filterable clearable placeholder="请选择" @change="Global.emptyQuery(query.sluiceType,searchTheData)">
            <el-option
              v-for="item in sluiceTypes"
              :key="item.name"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
          </div>
          <span class="xzqh">所属小流域:</span>
          <div class="selcountry">
          <el-select v-model="query.cacd" filterable clearable placeholder="请选择" @change="Global.emptyQuery(query.cacd,searchTheData)">
            <el-option
                v-for="item in cacds"
                :key="item.cacd"
                :label="item.canm"
                :value="item.cacd">
              </el-option>
          </el-select>
          </div>
          <span id="search" @click="searchTheData">查询</span>
          <span v-if="allowsPerm.delete" id="del" @click="delDialog"><span class="del-icon"></span>删除</span>
          <span v-if="allowsPerm.update" id="edit" @click="editDialog"><span class="edit-icon"></span>编辑</span>
          <span v-if="allowsPerm.insert" id="add" @click="addDialog"><span class="add-icon"></span>新增</span>
        </div>
        <div class="tablebox">
          <div class="fzxxtable">
            <el-table ref="multipleTable" @row-click="clickRow"  v-loading="loading" :data="tdata" :max-height="height" border @selection-change="handleSelectionChange">
              <el-table-column  type="selection" min-width="40" align="center">
              </el-table-column>
              <el-table-column  type="index" width="60"
                                label="序号" align="center"
                                header-align="center"
                                :index='(index)=>{return (index+1) + (pageIndex-1)*pageSize }'>
              </el-table-column>
              <el-table-column  prop="sluiceName" label="水闸名称" min-width="120">
              </el-table-column>
              <el-table-column prop="rvnm" label="所在河流" min-width="100">
              </el-table-column>
              <el-table-column prop="adcdnm"  label="乡镇" min-width="120">
              </el-table-column>
              <el-table-column prop="canm" label="所属小流域" min-width="80">
              </el-table-column>
              <el-table-column prop="sluiceType" label="水闸类型" min-width="100">
              </el-table-column>
              <el-table-column align="right" prop="holesCount" label="闸孔数量" min-width="60">
              </el-table-column>
              <el-table-column align="right" prop="holesmin-width" label="闸孔总净宽@(m)" :render-header="renderheader" min-width="70">
              </el-table-column>
              <el-table-column align="right" prop="gateFlow" label="过闸流量@(m³/s)" :render-header="renderheader" min-width="70">
              </el-table-column>
              <el-table-column align="right" prop="damHeight" label="橡胶坝坝高@(m)" :render-header="renderheader" min-width="70">
              </el-table-column>
              <el-table-column align="right" prop="damLength" label="橡胶坝坝长@(m)" :render-header="renderheader" min-width="70">
              </el-table-column>
               <!-- 列表默认不显示经纬度坐标 -->
              <el-table-column prop="lng"  label="经度" min-width="150" v-if= "false">
              </el-table-column>
              <el-table-column prop="lat"  label="纬度" min-width="150" v-if= "false">
              </el-table-column>
            </el-table>
          </div>
        </div>
        <pager
            @current-change="onCurrentChange"
            @size-change="onSizeChange"
            :pageIndex="pageIndex"
            :pageSize="pageSize"
            :total="total"
        ></pager>
      </div>
    </div>
     <el-dialog
      class="abow_dialog"
      :title="status + '水闸信息'"
      :close-on-click-modal="false"
      :visible.sync="addbtn">
      <el-form ref="groupForm" :model="form" :rules="rules" label-width="170px" label-height="40px">
        <el-form-item label="水闸名称:" prop="sluiceName">
          <el-input v-model="form.sluiceName"></el-input>
        </el-form-item>
        <el-form-item label="所在河流:" prop="rvnm">
          <el-input v-model="form.rvnm"></el-input>
        </el-form-item>
        <el-form-item label="乡镇:" prop="adcdid">
          <el-cascader
            v-model="form.adcdid"
            separator="-"
            :options="mutiRanksAdcd"
            :props="{ expandTrigger: 'hover' }"
            change-on-select
            >
          </el-cascader>
        </el-form-item>
          <el-form-item label="经度:" prop="lng">
          <el-input v-model="form.lng"></el-input>
        </el-form-item>
        <el-form-item label="纬度:" prop="lat">
          <el-input v-model="form.lat"></el-input>
           <DrawPoint :globalmapId='globalmapId' :latlng='latlngarr' @changeAdd='handleChangeAdd'></DrawPoint>
        </el-form-item>
        <el-form-item label="所属小流域:" prop="cacd">
          <el-select v-model="form.cacd" filterable clearable placeholder="请选择">
          <el-option
              v-for="item in cacds"
              :key="item.id"
              :label="item.canm"
              :value="item.cacd">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="水闸类型:" prop="sluiceType">
          <el-select v-model="form.sluiceType" filterable clearable placeholder="请选择">
            <el-option
              v-for="item in sluiceTypes"
              :key="item.id"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="闸孔数量:" prop="holesCount">
          <el-input v-model="form.holesCount"></el-input>
        </el-form-item>
        <el-form-item label="闸孔总净宽:" prop="holesWidth">
          <el-input v-model="form.holesWidth"></el-input>
          <label>(m)</label>
        </el-form-item>
        <el-form-item label="过闸流量:">
          <el-input v-model="form.gateFlow"></el-input>
          <label>(m³/s)</label>
        </el-form-item>
        <el-form-item label="橡胶坝坝高:" prop="damHeight">
            <el-input v-model="form.damHeight"></el-input>
            <label>(m)</label>
        </el-form-item>
        <el-form-item label="橡胶坝坝长:" prop="damLength">
          <el-input v-model="form.damLength"></el-input>
          <label>(m)</label>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addbtn = false">取 消</el-button>
        <el-button type="primary" @click="onGroupSave">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import scenceTypes from '@/store/types/scence'
import baseTypes from '@/store/types/base'
import Pager from '@/components/Pager'
import DrawPoint from '@/components/DrawPoint'
export default {
  props: ['addvcd'],
  components: {
    Pager,
    DrawPoint
  },
  data () {
    return {
      loading: true,
      height: 10,
      form: {},
      query: {
        adcdA: []
      },
      globalmapId: 'baseInfo',
      latlngarr: [],
      lat: 28.273886, // 新增初始地图中心经纬度坐标
      lng: 120.690968,
      rules: {
        sluiceName: [
          { required: true, message: '水闸名称不能为空' }
        ],
        rvnm: [
          { required: true, message: '所在河流不能为空' }
        ],
        adcdid: [
          { required: true, message: '请选择乡镇' }
        ],
        cacd: [
          { required: true, message: '请选择所属小流域' }
        ],
        sluiceType: [
          { required: true, message: '请选择水闸类型' }
        ],
        holesCount: [
          { validator: this.Global.checkNumeral, trigger: 'blur' }
        ],
        holesWidth: [
          { validator: this.Global.checkNumeral, trigger: 'blur' }
        ],
        damHeight: [
          { validator: this.Global.checkNumeral, trigger: 'blur' }
        ],
        damLength: [
          { validator: this.Global.checkNumeral, trigger: 'blur' }
        ],
        lng: [
          { validator: this.Global.checkNumeral, trigger: 'blur' }
        ],
        lat: [
          { validator: this.Global.checkNumeral, trigger: 'blur' }
        ]
      },
      addbtn: false,
      pageIndex: 1,
      pageSize: 20,
      total: 0,
      cPageIndex: '1',
      cPageSize: '100',
      tdata: [],
      multipleSelection: [],
      status: '新增',
      sluiceTypes: [],
      cacds: [],
      aDCD: '330324',
      mutiRanksAdcd: [],
      all: true
    }
  },
  watch: {
    addvcd (val, oldVal) { // 普通的watch监听
      this.loading = true
      this.pageIndex = 1 // 重置页码
      this.query.adcd = val
      this.thedata()
    }
  },
  methods: {
    handleChangeAdd (data) {
      // this.form.lng = data.lng
      // this.form.lat = data.lat
      this.form.lng = this.$set(this.form, 'lng', data.lng)
      this.form.lat = this.$set(this.form, 'lat', data.lat)
    },
    onSizeChange (pageSize) {
      this.pageIndex = 1
      this.pageSize = pageSize
      this.thedata()
    },
    onCurrentChange (pageIndex) {
      this.pageIndex = pageIndex
      this.thedata()
    },
    searchTheData () {
      this.pageIndex = 1 // 重置页码
      this.thedata()
    },
    // 表头换行
    renderheader (h, { column, $index }) {
      return h('span', {}, [
        h('span', {}, column.label.split('@')[0]),
        h('br'),
        h('span', {}, column.label.split('@')[1])
      ])
    },
    //  行选中
    clickRow (row) {
      this.$refs.multipleTable.toggleRowSelection(row)
    },
    thedata () {
      this.loading = true
      this.$store.dispatch(scenceTypes.GET_SLUICE, { adcd: this.query.adcd, cacd: this.query.cacd, sluiceType: this.query.sluiceType, searchName: this.query.searchName, pageIndex: this.pageIndex, pageSize: this.pageSize }).then(data => {
        this.tdata = data.results
        this.total = data.total
        this.loading = false
      })
    },
    getMutiRanksAdcd () {
      this.$store.dispatch(scenceTypes.GET_MUTIRANKS_ADCD, {
        parentAdcdCode: this.aDCD
      }).then(data => {
        this.mutiRanksAdcd = data.results
      })
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    // 新增
    addDialog () {
      this.status = '新增'
      this.latlngarr = [] // 重置经纬度
      this.form = {}
      // this.form = Object.assign({}, { lat: this.lat, lng: this.lng })
      // this.latlngarr.push(this.lng, this.lat)
      this.addbtn = true
      this.Global.clearValidate(this, 'groupForm')
    },
    // 编辑
    editDialog () {
      if (this.multipleSelection.length === 1) {
        this.status = '编辑'
        this.latlngarr = [] // 重置经纬度
        this.form = Object.assign({}, this.multipleSelection[0])
        this.$set(this.form, 'adcdid', this.getAdcdid(this.multipleSelection[0].adcdid, this.mutiRanksAdcd))
        this.addbtn = true
        this.latlngarr.push(this.form.lng, this.form.lat)
        this.Global.clearValidate(this, 'groupForm')
      } else {
        this.$alert('必需只选择一条信息', '提示')
      }
    },
    // 删除
    delDialog () {
      if (this.multipleSelection.length < 1) {
        this.$alert('必需选择一条信息', '提示')
      } else {
        let ids = []
        this.multipleSelection.forEach(function (item) {
          ids.push(item.id)
        })
        this.$confirm(`确定要删除已选择的水闸信息 ?`, '确认').then(() => {
          this.loading = true
          this.$store.dispatch(scenceTypes.DELETE_SLUICE, { id: ids.join(',') }).then(() => {
            this.multipleSelection = []
            this.$notify.success({ title: '成功', message: '删除数据成功.' })
            this.thedata()
            this.loading = false
          }).catch(() => { this.loading = false })
        }).catch(() => {})
      }
    },
    // 保存新增/编辑
    onGroupSave () {
      this.$refs['groupForm'].validate((valid) => {
        if (valid) {
          this.loading = true
          if (this.form.adcdid !== undefined && this.form.adcdid.length > 0) {
            let adcdidLength = this.form.adcdid.length
            this.form.adcdid = this.form.adcdid[adcdidLength - 1]
          }
          this.$store.dispatch(scenceTypes.SAVE_SLUICE, this.form).then(() => {
            this.$notify.success({ title: '成功', message: '保存成功。' })
            this.thedata()
            this.loading = false
            this.addbtn = false
            this.form = {}
            this.multipleSelection = []
          }).catch(() => { this.loading = false })
        }
      })
    },
    getDict (type) {
      this.$store.dispatch(baseTypes.GET_DICT, { type: type }).then(data => {
        switch (type) {
          case 'SluiceType':
            this.sluiceTypes = data
            break
          default:
        }
      }).catch(() => {})
    },
    getCacd () {
      this.$store.dispatch(baseTypes.GET_CACD, { pageIndex: this.cPageIndex, pageSize: this.cPageSize }).then(data => {
        this.cacds = data.results
      }).catch(() => {})
    },
    getAdcdid (val, dataSource) {
      let returnArray = []
      if (val !== undefined && val !== '' && dataSource !== undefined && dataSource.length > 0) {
        for (let index = 0; index < dataSource.length; index++) {
          const element = dataSource[index]
          if (element.value === val) {
            returnArray.unshift(element.value)
            break
          } else {
            returnArray = this.getAdcdid(val, element['children'])
            if (returnArray.length > 0) {
              returnArray.unshift(element.value)
              break
            }
          }
        }
      }
      return returnArray
    }
  },
  computed: {
    allowsPerm: {
      get () {
        return this.$store.state.allowPerm
      },
      set () {
        this.$store.dispatch('setAllowPerm', { name: this.$route.meta, type: this.$route.name })
      }
    }
  },
  created () {
    this.$store.dispatch('setAllowPerm', { name: this.$route.meta, type: this.$route.name })
    this.thedata()
    this.getDict('SluiceType')
    this.getCacd()
    this.getMutiRanksAdcd()
  },
  mounted () {
    this.$nextTick(() => {
      let sktDiv = document.getElementsByClassName('skt')
      this.height = sktDiv[0].offsetHeight - 120
    })
  }
}
</script>
<style lang="less" src="@/assets/scene.less" scoped>
</style>
<style scoped>
.scence .content{
  padding: 0!important;
}
.scence .skt{
  height: calc(100% - 139px);
}
.scence >>> .el-dialog__body {
  height: 70%;
  left: 0;
  top: 54px;
  bottom: 0;
  right: 0;
  z-index: 1;
  overflow: hidden;
  overflow-y: auto;
}
.scence >>> .el-dialog {
  margin: 0 auto !important;
  height: 580px !important;
}
.scence >>> .el-form-item{
  margin-left: 1%;
  width: 44% !important;
}
.countryList{
  height: 62px;
  background-color: #ffffff;
  border-radius: 5px;
  color: #444444;
  font-size: 15px;
}
.country{
  float: left;
  font-family: Microsoft YaHei UI;
  font-size: 15px;
  text-align: center;
  margin-top: 20px;
  margin-left: 0.5%;
  cursor: pointer;
}
.countryon{
  border-radius: 15px;
  background-color: #fda72c;
  color: #ffffff
}
.country span{
  padding: 4px 15px;
}
.global_map {
  position: absolute;
  right: 15px;
  top: 5px;
}
.scence >>>.el-form-item__content{
  width: 65%!important;
}
</style>
